import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { reduxForm } from 'redux-form';
import ModalForm from './ModalForm';
import SubmitModal from './SubmitModal';

export class ConfirmModal extends Component {
  render() {
    const {
      reject, confirm, children, modalOpen, dialogClassName, typeButton,
    } = this.props;
    return (
      <Modal dialogClassName={dialogClassName || ''} show={modalOpen} onHide={reject}>
        <Modal.Body className="text-center">{children}</Modal.Body>
        <Modal.Footer>
          <div className="">
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {text => (
                <button type="button" className="btn btn-default" onClick={reject}>
                  {text}
                </button>
              )}
            </FormattedMessage>
            &nbsp;
            <FormattedMessage id="actions.ok" defaultMessage="OK">
              {text => (
                <button type="button" className={`btn ${typeButton}`} onClick={confirm}>
                  {text}
                </button>
              )}
            </FormattedMessage>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  modalOpen: PropTypes.bool.isRequired,
  dialogClassName: PropTypes.string,
  typeButton: PropTypes.string,
};

ConfirmModal.defaultProps = {
  dialogClassName: '',
  typeButton: '',
};

export const ConfirmModalWithForm = reduxForm({
  destroyOnUnmount: false,
  enableReinitialize: true,
})(ModalForm);

export const SubmitModalWithForm = reduxForm({
  destroyOnUnmount: false,
  enableReinitialize: true,
})(SubmitModal);
